"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../");

require("./InboxEditor.scss");

var _InboxEditorCompose = _interopRequireDefault(require("./InboxEditorCompose"));

var _InboxEditorParent = _interopRequireDefault(require("./InboxEditorParent"));

var _InboxEditorArray = _interopRequireDefault(require("./InboxEditorArray"));

var _InboxEditorChild = _interopRequireDefault(require("./InboxEditorChild"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const layouts = {
  "inbox-compose": _InboxEditorCompose.default,
  "inbox-parent": _InboxEditorParent.default,
  "inbox-array": _InboxEditorArray.default,
  "inbox-child": _InboxEditorChild.default
};

class InboxEditor extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      preview: {},
      formData: {}
    });

    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevProps.formData !== this.props.formData) {
        this.getFormData();
        this.getFormContext();
      }
    });

    _defineProperty(this, "getFormData", () => {
      const _this$props = this.props,
            user = _this$props.user,
            status = _this$props.status,
            formData = _this$props.formData;

      if (status === "new") {
        const from = user.name + " <" + user.email + ">";
        this.setState({
          formData: _extends({}, formData, {
            messages: [{
              from: from,
              author: user
            }]
          })
        });
        return;
      }

      this.setState({
        formData: formData
      });
    });

    _defineProperty(this, "getFormContext", () => {
      const _this$props2 = this.props,
            user = _this$props2.user,
            formData = _this$props2.formData;
      const messages = formData.messages || [];
      const author = {
        id: user.id || undefined,
        uniqueId: user.uniqueId || undefined,
        name: user.name || undefined,
        imageUrl: user.imageUrl || undefined
      };
      const formContext = {
        author: user,
        messagesCount: messages.length,
        onSelect: this.onSelect,
        onDiscardDraft: this.onDiscardDraft,
        onEditMessage: this.onEditMessage,
        onSaveMessage: this.onSaveMessage,
        onDeleteMessage: this.onDeleteMessage,
        onSaveReply: this.onSaveReply,
        onDiscardReply: this.onDiscardReply
      };
      this.setState({
        formContext: formContext
      });
    });

    _defineProperty(this, "onSelect", props => {
      if (this.props.onSelect) {
        this.props.onSelect(props);
      }
    });

    _defineProperty(this, "onChange", props => {
      console.log('InboxEditor:onChange', props);
      const formData = props.formData;
      const messages = formData.messages || [];
      this.setState({
        formData: formData,
        formContext: _extends({}, this.state.formContext, {
          messagesCount: messages.length
        })
      });

      if (this.props.onChange) {
        this.props.onChange(this.state);
      }
    });

    _defineProperty(this, "onDiscardDraft", props => {
      console.log('InboxEditor:onDiscardDraft', props);

      if (this.props.onDiscardDraft) {
        this.props.onDiscardDraft(props);
      }
    });

    _defineProperty(this, "onEditMessage", props => {
      console.log('InboxEditor:onEditMessage', props);

      if (this.props.onEditMessage) {
        this.props.onEditMessage(props);
      }
    });

    _defineProperty(this, "onSaveMessage", props => {
      console.log('InboxEditor:onSaveMessage', props);

      if (this.props.onSaveMessage) {
        this.props.onSaveMessage(props);
      }
    });

    _defineProperty(this, "onDeleteMessage", props => {
      console.log('InboxEditor:onDeleteMessage', props);

      if (this.props.onDeleteMessage) {
        this.props.onDeleteMessage(props);
      }
    });

    _defineProperty(this, "onSaveReply", props => {
      console.log('InboxEditor:onSaveReply', props);

      if (this.props.onSaveReply) {
        this.props.onSaveReply(props);
      }
    });

    _defineProperty(this, "onDiscardReply", props => {
      console.log('InboxEditor:onDiscardReply', props);

      if (this.props.onDiscardReply) {
        this.props.onDiscardReply(props);
      }
    });
  }

  componentDidMount() {
    this.getFormData();
    this.getFormContext();
  }

  render() {
    const _this$props3 = this.props,
          status = _this$props3.status,
          schema = _this$props3.schema,
          uiSchema = _this$props3.uiSchema,
          uiSchemaCompose = _this$props3.uiSchemaCompose,
          user = _this$props3.user;
    const _this$state = this.state,
          formData = _this$state.formData,
          formContext = _this$state.formContext;

    if (status === "new") {
      return _react.default.createElement(_.Schema, {
        schema: schema,
        uiSchema: uiSchemaCompose,
        formData: formData,
        formContext: formContext,
        layouts: layouts,
        onChange: this.onChange,
        onSubmit: this.onSubmit
      });
    }

    return _react.default.createElement(_.Schema, {
      schema: schema,
      uiSchema: uiSchema,
      formData: formData,
      formContext: formContext,
      layouts: layouts,
      onChange: this.onChange,
      onSubmit: this.onSubmit
    });
  }

}

_defineProperty(InboxEditor, "defaultProps", {
  status: "",
  user: {},
  formData: {
    messages: []
  },
  schema: {
    type: "object",
    properties: {
      uniqueId: {
        type: "string",
        readonly: true
      },
      appName: {
        type: "string"
      },
      appColor: {
        type: "string"
      },
      ownerName: {
        type: "string"
      },
      inboxType: {
        type: "string",
        enum: ["message", "comments", "issue"],
        default: "message"
      },
      attachments: {
        type: "array",
        items: {
          type: "object",
          properties: {
            uniqueId: {
              type: "string"
            },
            url: {
              type: "string"
            },
            title: {
              type: "string"
            },
            description: {
              type: "string"
            },
            imageUrl: {
              type: "string"
            }
          }
        }
      },
      messages: {
        type: "array",
        items: {
          type: "object",
          properties: {
            status: {
              type: "string"
            },
            parentId: {
              type: "string",
              readonly: true
            },
            uniqueId: {
              type: "string",
              readonly: true
            },
            createdAt: {
              type: "string"
            },
            updatedAt: {
              type: "string"
            },
            author: {
              type: "object",
              properties: {
                name: {
                  type: "string"
                },
                email: {
                  type: "string"
                }
              }
            },
            from: {
              type: "string"
            },
            to: {
              type: "string"
            },
            subject: {
              type: "string"
            },
            message: {
              type: "string"
            }
          }
        }
      }
    }
  },
  uiSchema: {
    "ui:layout": "inbox-parent",
    "ui:fieldset": ["messages"],
    "messages": {
      "ui:title": undefined,
      "ui:layout": "inbox-array",
      "ui:options": {
        "orderable": false
      },
      "ui:buttons": [{
        "label": "Reply",
        "item": {
          "status": "reply"
        }
      }],
      "items": {
        "ui:layout": "inbox-child",
        "ui:options": {
          "collapsible": true,
          "editable": true
        },
        "ui:fieldset": ["message", "footer"],
        "message": {
          "ui:widget": "textarea",
          "ui:label": false
        },
        "ui:title": {
          "select": "message"
        }
      }
    }
  },
  uiSchemaCompose: {
    "ui:layout": "inbox-parent",
    "uniqueId": {
      "ui:hidden": true
    },
    "messages": {
      "ui:title": undefined,
      "ui:layout": "inbox-array",
      "ui:options": {
        "orderable": false
      },
      "ui:buttons": [{
        "label": "Reply",
        "item": {
          "status": "reply"
        }
      }],
      "items": {
        "ui:layout": "inbox-compose",
        "ui:options": {
          "collapsible": true,
          "editable": true
        },
        "ui:fieldset": ["from", "to", "subject", "message", "footer"],
        "message": {
          "ui:widget": "textarea"
        },
        "ui:title": {
          "select": "message"
        }
      }
    }
  }
});

InboxEditor.propTypes = process.env.NODE_ENV !== "production" ? {} : {};
var _default = InboxEditor;
exports.default = _default;
module.exports = exports.default;